import { render, staticRenderFns } from "./MyTaskShow.vue?vue&type=template&id=0dae5084"
import script from "./MyTaskShow.vue?vue&type=script&lang=js"
export * from "./MyTaskShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports